import { filter, fromPairs, pipe, toPairs } from 'ramda'

const skipNullValues = pipe(
  toPairs,
  filter(([, value]) => value !== null && value !== undefined),
  fromPairs
)

export default skipNullValues
